import { render, staticRenderFns } from "./BusAssignments.vue?vue&type=template&id=128232b4&scoped=true&"
import script from "./BusAssignments.vue?vue&type=script&lang=js&"
export * from "./BusAssignments.vue?vue&type=script&lang=js&"
import style0 from "./BusAssignments.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BusAssignments.vue?vue&type=style&index=1&id=128232b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128232b4",
  null
  
)

export default component.exports